export const Warning = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.2"
                d="M18.6702 4.19433C19.0664 3.60499 19.9336 3.60499 20.3298 4.19433L37.9524 30.4022C38.3991 31.0665 37.923 31.9602 37.1225 31.9602H1.87746C1.07697 31.9602 0.600945 31.0665 1.04762 30.4022L18.6702 4.19433Z"
                fill="#24B98C"
            />
            <ellipse cx="19.5" cy="26.1238" rx="1.05224" ry="1.09301" fill="#24B98C" />
            <path
                d="M18.4827 14.9229C18.4636 14.3577 18.9166 13.8892 19.4821 13.8892H19.5179C20.0834 13.8892 20.5364 14.3577 20.5173 14.9229L20.2252 23.5716C20.212 23.9626 19.8912 24.2727 19.5 24.2727C19.1088 24.2727 18.788 23.9626 18.7748 23.5716L18.4827 14.9229Z"
                fill="#24B98C"
            />
        </svg>
    );
};
